<template>
  <div class="share">
    <!--<div class="good" v-if="good"><span class="icon-img icon-good"></span>{{good}}</div>-->
    <!--<div class="preview" v-if="share"><span class="icon-img icon-preview"></span>{{share}}</div>-->
    <!--<div class=""><span class="icon-img icon-share"></span></div>-->
  </div>
</template>

<script>
export default {
  props: ['share', 'good'],
  name: 'share',
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .share{
    display: flex;
    justify-content:flex-end;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    align-items: center;
  }
  .share>div{
    position: relative;
    padding-left: 20px;
    margin-right: 15px;
  }
  .share .icon-img{
    position: absolute;
    top:50%;
    left: 0;
    margin-top: -10px;
  }
  .share .good{
    padding-left: 22px;
  }
  .share .icon-good{
    margin-top: -12px;
  }
  .share>.preview{
    padding-left: 26px;
  }
  .share>div:last-child{
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/share.vue